import React, { useState } from 'react';
import { Tabs } from 'antd';
import { useQuery } from 'react-query';
import { Col, Row } from 'reactstrap';
import '../utils/style.css';
import AddReversement from '../component/versement/addVersement';
import { getAccountsPaiementByMerchantId } from '../../payements/services/paymentApi';
import Accounts from '../component/mobile/accounts';
import AccountsBanks from '../component/bank/accountsBanks';
import { getAccountsBanksByMerchantId } from '../services/bankApi';
import History from '../component/historique/historique';

const { TabPane } = Tabs;

const Versement = () => {
  document.title = `Reversement | ${process.env.REACT_APP_NAME} - ${process.env.REACT_APP_DESCRIPTION}`;

  const currentUser = JSON.parse(sessionStorage.getItem("authUser"));
  const merchandId = currentUser?.user?.id || currentUser?.user?.merchantId;
  const token = currentUser?.token;

  const {
    data: accountsList,
    isLoading: isLoadAccount,
    isError: isErrorAcc,
    error: errorAcc,
  } = useQuery(
    ["accounts", merchandId],
    () => getAccountsPaiementByMerchantId(merchandId),
    { enabled: !!merchandId }
  );
  const { data: accountsBanksList = [], isLoading : isLoadBanks, isError: isErrorBanks, error : errorBanks } = useQuery(
    ["accountsBanks", merchandId],
    () => getAccountsBanksByMerchantId(merchandId, token),
    { enabled: !!merchandId }
  );

  const accounts = Array.isArray(accountsList) ? accountsList : [];
  const accountsBanks = Array.isArray(accountsBanksList) ? accountsBanksList : [];

  const [activeTab, setActiveTab] = useState("demande");

  return (
    <div>
      <Row>
        <Col lg={1}></Col>
        <Col lg={10}>
          <div className="title-page mb-2 mt-4">Demander un reversement</div>
          <div className="verse-description">
            <span role="img" aria-label="lightbulb">
              💡
            </span>
            Initiez une demande de virement en sélectionnant l’entreprise et le
            montant souhaité, puis recevez les fonds sur le compte de votre
            choix. Vous pouvez naviguer entre les onglets pour ajouter un
            compte, effectuer un virement ou consulter vos historiques.
          </div>
          <Tabs
            activeKey={activeTab}
            onChange={setActiveTab}
            className="versement-tabs"
          >
            <TabPane tab="Demande de reversement" key="demande">
              <AddReversement 
                accounts={accounts} 
                isLoadAccount={isLoadAccount} 
                isErrorAcc={isErrorAcc} 
                errorAcc={errorAcc} 
                onSuccessReversement={() => setActiveTab("historique")} 
                accountsBanks={accountsBanks}
                isLoadBanks={isLoadBanks} 
                isErrorBanks={isErrorBanks}
                errorBanks={errorBanks}
              />
            </TabPane>
            <TabPane tab={`Mes comptes mobile money (${accounts?.length || 0})`} key="mobileMoney">
              <Accounts accounts = {accounts} isLoadAccount={isLoadAccount} isErrorAcc={isErrorAcc} errorAcc={errorAcc} onSuccessMobile={() => setActiveTab("mobileMoney")} />
            </TabPane>
            <TabPane tab={`Mes comptes bancaires (${accountsBanks?.length || 0})`} key="bancaires">
              <AccountsBanks accountsBanks = {accountsBanks} isLoadBanks={isLoadBanks} isErrorBanks={isErrorBanks} errorBanks={errorBanks} onSuccessBank={() => setActiveTab("bancaires")} />
            </TabPane>
            <TabPane tab="Historique des versements" key="historique">
              <History />
            </TabPane>
          </Tabs>
        </Col>
        <Col lg={1}></Col>
      </Row>
    </div>
  );
};

export default Versement;
